import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ComponentFactoryResolver } from '@angular/core';
import { DataEntityViewComponent } from './../../data-entity-view/data-entity-view.component';
import { Component, OnInit } from '@angular/core';
import { RichTextDataEntity } from 'src/app/models/data-entities/rich-text-data-entity';
import { WorkflowContextService } from 'src/app/services/workflow-context.service';
import { LayoutService } from 'src/app/services/layout.service';

@Component({
    selector: 'wm-rich-text-data-entity-view',
    templateUrl: './rich-text-data-entity-view.component.html',
    styleUrls: ['./rich-text-data-entity-view.component.css'],
    standalone: false
})
export class RichTextDataEntityViewComponent extends DataEntityViewComponent
  implements OnInit {
  public de: RichTextDataEntity;

  public html: SafeHtml;

  constructor(
    public layoutService: LayoutService,
    private sanitizer: DomSanitizer,
    componentFactoryResolver: ComponentFactoryResolver,
    context: WorkflowContextService
  ) {
    super(layoutService, componentFactoryResolver, context);
  }

  ngOnInit() {
    this.de = this.entity as RichTextDataEntity;

    // we sanitize the html server side so this is safe
    this.html = this.sanitizer.bypassSecurityTrustHtml(this.de.renderedHtml);
  }
}
